import { Page } from '@/components';
import { useApi } from '@/api';
import { useParams } from 'react-router';
import { Flex, KpiCard, WalletAddress } from '@blockanalitica/ui';
import { useNetwork } from '@/hooks';
import CollateralBuyerTable from './CollateralBuyerTable';

type LiquidationsResponse = {
  liquidation_count: string | null;
  collateral_amount_usd: string | null;
  debt_amount_usd: string | null;
  liquidation_penalty: string | null;
  underlying_symbol: string;
  underlying_address: string;
  wallet_address: string;
};

export default function MarketPage() {
  const network = useNetwork() as string;
  const { marketAddress, walletAddress } = useParams() as {
    marketAddress: string;
    walletAddress: string;
  };

  const [data, error] = useApi<LiquidationsResponse>({
    url: `/markets/${marketAddress}/liquidations/collateral-buyers/${walletAddress}/stats/`,
    queryParams: {}
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <WalletAddress
            options={{
              name: 'Collateral Buyer',
              showCopyBtn: true,
              showEthScanLink: true,
              showDebankLink: true,
              inline: true,
              sizes: {
                blockie: '6',
                walletAddressHeader: '2'
              }
            }}
            address={data.wallet_address}
          />
        }>
        <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
          <KpiCard title="Collateral Buys" data={data} field="count" />
          <KpiCard
            title="Collateral Sold"
            data={data}
            field="amount_base"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: {
                    name: data.underlying_symbol,
                    address: data.underlying_address,
                    network: network
                  },
                  notation: 'compact'
                }
              }
            }}
          />
        </Flex>
        <CollateralBuyerTable
          marketAddress={marketAddress}
          network={network}
          walletAddress={walletAddress}
        />
      </Page>
    );
  }
  return <></>;
}
